module.exports = __webpack_public_path__ + "img/title8.05cfddb9.png";